// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".personalization-settings #content input[data-v-40a92bb6] {\n  color: #495057;\n  border: 1px solid #ced4da;\n  background-color: #fff;\n}\nh4[data-v-40a92bb6], p[data-v-40a92bb6] {\n  font-size: 15px;\n}\nh4[data-v-40a92bb6] {\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
